import React from 'react';
export type ExamStatus = 'Programmato' | 'In attesa' | 'In corso' | 'Dati ricevuti' | 'Da refertare' | 'Refertato' | 'Consegnato' | 'Inviato';
export type MachineStatus = 'Connesso' | 'Disconnesso' | 'Errore' | 'Non in funzione' | 'Manutenzione' | 'Test';
interface StatusBadgeProps {
  status: ExamStatus | MachineStatus | string;
  className?: string;
}
export function StatusBadge({
  status,
  className = ''
}: StatusBadgeProps) {
  const getStatusStyles = (s: string) => {
    switch (s) {
      // Exam Statuses
      case 'Programmato':
        return 'bg-status-info-bg text-status-info';
      case 'In attesa':
        return 'bg-clinical-gray-200 text-text-primary font-medium';
      case 'In corso':
        return 'bg-medical-green-50 text-medical-green';
      case 'Dati ricevuti':
        return 'bg-medical-green-100 text-medical-green-light';
      case 'Da refertare':
        return 'bg-medical-orange-50 text-medical-orange';
      case 'Refertato':
        return 'bg-status-success-bg text-status-success';
      case 'Consegnato':
        return 'bg-green-100 text-green-700';
      case 'Inviato':
        return 'bg-emerald-100 text-emerald-700 font-semibold';
      // Machine Statuses
      case 'Connesso':
        return 'bg-status-success-bg text-status-success';
      case 'Disconnesso':
        return 'bg-clinical-gray-200 text-text-secondary';
      case 'Errore':
        return 'bg-status-error-bg text-status-error';
      case 'Non in funzione':
        return 'bg-red-100 text-red-700 font-semibold';
      case 'Manutenzione':
        return 'bg-status-warning-bg text-status-warning';
      case 'Test':
        return 'bg-status-info-bg text-status-info';
      // Default
      default:
        return 'bg-clinical-gray-100 text-text-secondary';
    }
  };
  return <span className={`medical-badge whitespace-nowrap ${getStatusStyles(status)} ${className}`} data-id="element-251">
      {status}
    </span>;
}